:host {
  display: block;
}

::slotted([slot=error]) {
  margin-top: 6px;
  color: #b10043;
}

.runtime-base-cell__value {
  line-height: 30px;
}